


























import Vue, { PropOptions } from 'vue';
import util from '@/components/util';
import BasicGadget, {CFrame} from '@/components/gadgets/BasicGadget.vue';
import Gadgets from '@/components/gadgets';
import * as models from '@/class/models/views/graph';

export interface ISettings {
  edit: boolean;
  add: boolean;
}

export class CSettings implements ISettings {
  public edit = false;
  public add  = false;
}

export default Vue.extend({
  name: 'DashboardSpModal',
  components: {
    ...util, BasicGadget,
  },
  props: {
    gadgets: Array as PropOptions<models.IGadget[]>,
    settings: {
      type: Object as () => ISettings,
      default: () => new CSettings(),
    },
    addGadgetLock: {
      type: Function,
    },
  },
  data() {
    return {
      selectGadgets: [] as models.IGadget[],
      componentGadgets: Gadgets,
    };
  },
  computed: {
    GADGET_LIST_SETTINGS(): object {
      return {
        edit: true,
        add: true,
        tab: true,
      };
    },

  },
  methods: {
    onClickClose() {
      this.$emit('close');
    },
    onClickAddGraph() {
      window.scrollTo(0, 0);
      this.$emit('addGraph');
    },
    generateModal() {
      window.scrollTo(0, 0);
      this.$emit('generate');
    },
    editDashBoard() {
      window.scrollTo(0, 0);
      this.$emit('edit');
    },
  },
});
